module.exports = __webpack_public_path__ + "img/login_img.649c3247.png";